<template>
  <div>
    <div v-if="$store.getters.nivel != 1 && $store.getters.nivel != 25" class="mt-4 text-subtitle-1">{{ $store.getters.nome }} seja bem vindo ao SIGEFIS!</div>
    <div v-if="$store.getters.nivel == 1 || $store.getters.nivel == 25">
      <v-container>
        <!-- #region Cards Tarefa -->
        <v-row class="mb-6" no-gutters>
          <v-col class="pa-md-1">
            <v-card class="orange lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 0, 'Em Andamento')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaEmAndamento }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Tarefas em Andamento</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="blue lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 1, 'Respondidas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaRespondidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Tarefas Respondidas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="red lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 2, 'Adiadas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaAdiadas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Tarefas Adiadas</v-card-actions>
            </v-card>
          </v-col>

          <v-col class="pa-md-1">
            <v-card class="yellow lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 4, 'Processo Aberto')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaProcessosAbertos }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Tarefas Processo Aberto</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 3, 'Concluídas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaConcluidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Tarefas Concluídas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(0, 'Tarefas', 1, 'Respondidas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeTarefaRespondidas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Tarefas Concluídas</v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- #endregion -->

        <!-- #region Cards Denuncias -->
        <v-row class="mb-6" no-gutters>
          <v-col class="pa-md-1">
            <v-card class="orange lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 0, 'Em Andamento')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaEmAndamento }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Denúncias em Andamento</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="blue lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 1, 'Respondidas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaRespondidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Denúncias Respondidas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="red lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 2, 'Adiadas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaAdiadas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Denúncias Adiadas</v-card-actions>
            </v-card>
          </v-col>

          <v-col class="pa-md-1">
            <v-card class="yellow lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 4, 'Processo Aberto')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaProcessosAbertos }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Denúncias Processo Aberto</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 3, 'Concluídas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaConcluidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Denúncias Concluídas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(1, 'Denúncias', 1, 'Respondidas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeDenunciaRespondidas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Denúncias Concluídas</v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- #endregion -->

        <!-- #region Cards Retornos -->
        <v-row class="mb-6" no-gutters>
          <v-col class="pa-md-1">
            <v-card class="orange lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 0, 'Em Andamento')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoEmAndamento }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Retornos em Andamento</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="blue lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 1, 'Respondidas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoRespondidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Retornos Respondidas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="red lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 2, 'Adiadas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoAdiadas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Retornos Adiadas</v-card-actions>
            </v-card>
          </v-col>

          <v-col class="pa-md-1">
            <v-card class="yellow lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 4, 'Processo Aberto')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoProcessosAbertos }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Retornos Processo Aberto</v-card-actions>
            </v-card>
          </v-col>

          <!-- <v-col class="pa-md-1">
        <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 3, 'Concluídas')">
          <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoConcluidas }}</v-card-title>
          <v-card-actions class="grey--text text--darken-1">Retornos Concluídas</v-card-actions>
        </v-card>
      </v-col> -->

          <v-col class="pa-md-1">
            <v-card class="green lighten-3" dark @click="abrirTabelaSelecionada(2, 'Retornos', 1, 'Respondidas')">
              <v-card-title class="headline grey--text text--darken-1">{{ cardData.quantidadeRetornoRespondidas }}</v-card-title>
              <v-card-actions class="grey--text text--darken-1">Retornos Concluídas</v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- #endregion -->

        <v-row class="mb-6">
          <v-col class="pa-md-3 mx-lg-auto" cols="12">
            <v-card class="pa-md-3">
              <v-card-title class="headline">Tarefas, Denúncias e Retornos</v-card-title>
              <v-card-text id="cardTipos">
                <Bar height="100%" :chartData="dadosDeTarefaDenunciaRetorno" :options="optionsBar"></Bar>
              </v-card-text>
            </v-card>
          </v-col>

          <v-expand-transition>
            <v-col v-if="abrirGraficoDeAbertosEFechados" class="pa-md-3 mx-lg-auto" :cols="coluna" style="min-height: 300px">
              <v-card class="pa-md-3" height="100%">
                <v-card-title class="headline">Status de {{ tipoTarefaSelecionado.texto }}</v-card-title>
                <v-card-text id="cardStatus">
                  <Bar height="100%" :chartData="dadosDeStatus" :options="optionsBar"></Bar>
                </v-card-text>
              </v-card>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col v-if="abrirFiscaisPorStatus" class="pa-md-3 mx-lg-auto" cols="6">
              <v-card class="pa-md-3">
                <v-card-title class="headline">Usuários pelo Status: {{ statusTarefaSelecionado.texto }}</v-card-title>
                <v-card-text id="cardFiscais">
                  <Doughnut height="300px" :options="optionsDoughnut" :chartData="dadosDeFiscaisPorStatus"></Doughnut>
                </v-card-text>
              </v-card>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col v-if="abrirFiscal" class="pa-md-3 mx-lg-auto" cols="12">
              <v-card class="pa-md-3">
                <v-card-title class="headline">Fiscal selecionado:</v-card-title>
                <v-card-text id="cardFiscal">
                  <v-row>
                    <v-col cols="3">
                      <v-img :src="infoFiscal.fotoUsuario" :lazy-src="infoFiscal.fotoUsuario" aspect-ratio="1">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="blue lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-col>

                    <v-col cols="9">
                      <v-col cols="12">
                        <v-text-field readonly v-model="infoFiscal.nomeUsuario" name="nomeUsuario" label="Nome" autocomplete="off"></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field readonly v-model="infoFiscal.cpfUsuario" name="cpfUsuario" label="CPF" autocomplete="off"></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field readonly v-model="infoFiscal.emailUsuario" name="emailUsuario" label="Email" autocomplete="off"></v-text-field>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-expand-transition>

          <v-col class="pa-md-3 mx-lg-auto" cols="12">
            <v-card class="pa-md-3">
              <v-card-title class="headline">Licenças</v-card-title>
              <v-card-text>
                <Bar id="datatableLicenca" height="100%" :chartData="dadosLicencas" :options="optionsBar"></Bar>
              </v-card-text>
            </v-card>
          </v-col>

          <v-expand-transition>
            <v-col v-if="mostrarTabela" class="pa-md-3 mx-lg-auto" cols="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mb-2" icon v-bind="attrs" v-on="on" @click="mostrarTabela = false">
                    <v-icon>mdi-window-close</v-icon>
                  </v-btn>
                </template>
                <span>Fechar tabela</span>
              </v-tooltip>
              <DataTable :tableTitle="tituloTabela" :tableHeader="header" :tableRows="listaLicencas"></DataTable>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col v-if="mostrarTabelaComAcao" class="pa-md-3 mx-lg-auto" cols="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mb-2" icon v-bind="attrs" v-on="on" @click="mostrarTabelaComAcao = false">
                    <v-icon>mdi-window-close</v-icon>
                  </v-btn>
                </template>
                <span>Fechar tabela</span>
              </v-tooltip>
              <DataTable :tableTitle="'Licenças Próximas a Vencer'" :tableHeader="headerComActions" :tableRows="listaLicencas" :isAddNewTarefa="true" v-on:datatable-updaterow="onDataTableUpdateRow"></DataTable>
            </v-col>
          </v-expand-transition>

          <v-col class="pa-md-3 mx-lg-auto" cols="12">
            <v-card class="pa-md-3">
              <v-card-title class="headline">
                Renovações | {{ anoSelecionado }}
                <v-menu v-if="listaAnos.length > 1" offset-x transition="scale-transition">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn light icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                          <v-icon>mdi-autorenew</v-icon>
                        </v-btn>
                      </template>
                      <span>Alterar o Ano</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item v-for="(ano, i) in listaAnos" :key="i" @click="alterarAno(ano.value)">
                      <v-list-item-title>{{ ano.text }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text>
                <Bar height="100%" :chartData="dadosRenovacoes" :options="optionsBarWithNoOnClick"></Bar>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <ModalCustomSize
          :modalSize="modalCustomSizeData.modalSize"
          :isTheModalOpen="modalCustomSizeData.isOpen"
          :modalButtonText="modalCustomSizeData.buttonText"
          :modalFormTitle="modalCustomSizeData.formTitle"
          :modalType="modalCustomSizeData.modalType"
          :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
          :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
          :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
          v-on:formmodal-close="modalCustomSizeData.isOpen = false"
          v-on:formmodal-action="inserir"
        >
          <v-col cols="12">
            <v-alert transition="scale-transition" type="error" text hide-details="auto" v-show="mensagemModal.erro">{{ mensagemModal.text }}</v-alert>
          </v-col>

          <v-row>
            <v-col cols="12">
              <v-text-field v-model="modalCustomSizeData.actualEdit.nomeEmpresa" readonly name="nomeEmpresa" label="Nome do Empresa" autocomplete="off"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="modalCustomSizeData.actualEdit.nomeEndereco" readonly name="nomeEndereco" label="Nome do Endereço" autocomplete="off"></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-autocomplete label="Nome do Fiscal" :items="usuarios" v-model="modalCustomSizeData.actualEdit.numeroUsuario" name="numeroUsuario" autocomplete="off"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-autocomplete label="Roteiros" :items="roteiros" v-model="modalCustomSizeData.actualEdit.numeroRoteiro" name="numeroRoteiro" autocomplete="off"></v-autocomplete>
            </v-col>

            <v-col cols="6">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="dateFormatted" label="Data Prazo" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="date = parseDate(dateFormatted)" v-on="on" autocomplete="off"></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </ModalCustomSize>

        <v-fab-transition>
          <v-btn v-scroll="onScroll" v-show="mostrarFAB" fab dark fixed bottom right color="primary" class="my-lg-6" @click="irParaTopo">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </div>
  </div>
</template>

<script>
import Doughnut from "@/components/Charts/Doughnut";
import Bar from "@/components/Charts/Bar";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import axios from "@/plugins/axios";
import store from "@/store/index";
import colorPattern from "@/utils/colorPattern.js";

export default {
  components: {
    Doughnut,
    Bar,
    DataTable,
    ModalCustomSize,
  },

  data(vm) {
    return {
      mensagemModal: {
        erro: false,
        text: null,
      },

      tipoTarefaSelecionado: {
        texto: null,
        valor: null,
      },

      statusTarefaSelecionado: {
        texto: null,
        valor: null,
      },

      coluna: "12",
      mostrarFAB: false,

      abrirGraficoDeAbertosEFechados: false,
      abrirFiscaisPorStatus: false,
      abrirFiscal: false,

      mostrarTabela: false,
      mostrarTabelaComAcao: false,

      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu: false,

      anoSelecionado: new Date().getFullYear(),
      listaAnos: [],

      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },

      optionsDoughnut: {
        legend: {
          display: true,
        },
        onClick: (evt, array) => {
          if (array.length != 0) {
            var posicao = array[0]._index;
            var elementoClicado = array[0]._chart.tooltip._data.labels[posicao];
            this.verificarTipoStatusOuUsuarioSelecionado(elementoClicado);
          }
        },
      },

      optionsBar: {
        legend: {
          display: false,
        },
        onClick: (evt, array) => {
          if (array.length != 0) {
            var posicao = array[0]._index;
            var elementoClicado = array[0]._chart.tooltip._data.labels[posicao];
            this.verificarTipoStatusOuUsuarioSelecionado(elementoClicado);
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },

      optionsBarWithNoOnClick: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },

      header: [
        {
          text: "ID",
          value: "licenca.numeroLicenca",
        },
        {
          text: "Empresa",
          value: "empresa.nomeFantasia",
        },
        {
          text: "Endereço",
          value: "endereco.endereco",
        },
        {
          text: "CEVS",
          value: "endereco.cevs",
        },
        {
          text: "Responsável",
          value: "endereco.nomeResponsavel",
        },
        {
          text: "Data Vencimento",
          value: "licenca.dataVencimento",
        },
      ],

      headerComActions: [
        {
          text: "ID",
          value: "licenca.numeroLicenca",
        },
        {
          text: "Empresa",
          value: "empresa.nomeFantasia",
        },
        {
          text: "Endereço",
          value: "endereco.endereco",
        },
        {
          text: "CEVS",
          value: "endereco.cevs",
        },
        {
          text: "Responsável",
          value: "endereco.nomeResponsavel",
        },
        {
          text: "Data Vencimento",
          value: "licenca.dataVencimento",
        },
        { text: "Ações", value: "actions", sortable: false },
      ],

      modalCustomSizeData: {
        modalSize: "1100",
        isOpen: false,
        buttonText: "",
        formTitle: "",
        isEdit: false,
        isButtonsVisible: true,
        isButtonsDisabled: false,
        isLoadingRequestDisable: false,
        actualEdit: {
          numeroEmpresa: null,
          nomeEmpresa: null,
          numeroEndereco: null,
          nomeEndereco: null,
          numeroUsuario: null,
          numeroRoteiro: null,
          tipoTarefa: 0,
          statusTarefa: 0,
          dataTarefa: null,
          descricaoTela: "tarefas",
        },
      },

      listaLicencas: [],
      empresas: [],
      enderecoEmpresa: [],
      roteiros: [],
      usuarios: [],

      dadosDeTarefaDenunciaRetorno: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      dadosDeStatus: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      dadosDeFiscaisPorStatus: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      dadosLicencas: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      dadosRenovacoes: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      infoFiscal: {
        fotoUsuario: null,
        nomeUsuario: null,
        cpfUsuario: null,
        emailUsuario: null,
      },

      cardData: {
        quantidadeTarefaEmAndamento: null,
        quantidadeTarefaRespondidas: null,
        quantidadeTarefaAdiadas: null,
        quantidadeTarefaProcessosAbertos: null,
        quantidadeTarefaConcluidas: null,

        quantidadeDenunciaEmAndamento: null,
        quantidadeDenunciaRespondidas: null,
        quantidadeDenunciaAdiadas: null,
        quantidadeDenunciaProcessosAbertos: null,
        quantidadeDenunciaConcluidas: null,

        quantidadeRetornoEmAndamento: null,
        quantidadeRetornoRespondidas: null,
        quantidadeRetornoAdiadas: null,
        quantidadeRetornoProcessosAbertos: null,
        quantidadeRetornoConcluidas: null,
      },
    };
  },

  created() {
    this.gerarListaDeAnos();
    this.inicializar();
    this.dadosGraficoRenovacoes();
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.modalCustomSizeData.actualEdit.dataTarefa = this.date;
    },
  },

  methods: {
    async inicializar() {
      this.$vuetify.goTo(0);
      try {
        const responseData = await axios.get("/dashboard", this.config);
        this.dadosDeTarefaDenunciaRetorno = responseData.data.grafico;
        this.dadosLicencas = responseData.data.graficoLicenca;

        this.cardData.quantidadeTarefaEmAndamento = responseData.data.quantidadeTarefaEmAndamento;
        this.cardData.quantidadeTarefaRespondidas = responseData.data.quantidadeTarefaRespondidas;
        this.cardData.quantidadeTarefaAdiadas = responseData.data.quantidadeTarefaAdiadas;
        this.cardData.quantidadeTarefaProcessosAbertos = responseData.data.quantidadeTarefaProcessosAbertos;
        // this.cardData.quantidadeTarefaConcluidas = responseData.data.quantidadeTarefaConcluidas;

        this.cardData.quantidadeDenunciaEmAndamento = responseData.data.quantidadeDenunciaEmAndamento;
        this.cardData.quantidadeDenunciaRespondidas = responseData.data.quantidadeDenunciaRespondidas;
        this.cardData.quantidadeDenunciaAdiadas = responseData.data.quantidadeDenunciaAdiadas;
        this.cardData.quantidadeDenunciaProcessosAbertos = responseData.data.quantidadeDenunciaProcessosAbertos;
        // this.cardData.quantidadeDenunciaConcluidas = responseData.data.quantidadeDenunciaConcluidas;

        this.cardData.quantidadeRetornoEmAndamento = responseData.data.quantidadeRetornoEmAndamento;
        this.cardData.quantidadeRetornoRespondidas = responseData.data.quantidadeRetornoRespondidas;
        this.cardData.quantidadeRetornoAdiadas = responseData.data.quantidadeRetornoAdiadas;
        this.cardData.quantidadeRetornoProcessosAbertos = responseData.data.quantidadeRetornoProcessosAbertos;
        // this.cardData.quantidadeRetornoConcluidas = responseData.data.quantidadeRetornoConcluidas;
      } catch (error) {
        console.log(error);
      }
    },

    async dadosGraficoRenovacoes() {
      try {
        const responseData = await axios.put("/dashboardRenovacao", { anoSelecionado: this.anoSelecionado }, this.config);

        this.dadosRenovacoes = responseData.data.graficoRenovacoes;

        //Cores do gráfico "Renovações"
        for (let index of this.dadosRenovacoes.datasets[0].data.keys()) {
          this.dadosRenovacoes.datasets[0].backgroundColor.push(colorPattern[index]);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async inserir() {
      this.modalCustomSizeData.isLoadingRequestDisable = true;

      try {
        await axios.post("tarefas", this.modalCustomSizeData.actualEdit, this.config);
        this.modalCustomSizeData.isLoadingRequestDisable = false;

        this.modalCustomSizeData.isOpen = false;
      } catch (error) {
        this.mensagemModal.text = error.response.data.message;
        this.mensagemModal.erro = true;
        this.modalCustomSizeData.isOpen = true;
      } finally {
        this.inicializar();
      }
    },

    //#region FUNÇÕES DE EVENTOS AO CLICAR NOS GRAFICOS
    verificarTipoStatusOuUsuarioSelecionado(dadoSelecionado) {
      if (dadoSelecionado == "Tarefas") {
        this.buscaPorStatus(0, dadoSelecionado);
        this.coluna = "12";
        this.abrirFiscaisPorStatus = false;
      } else if (dadoSelecionado == "Denúncias") {
        this.buscaPorStatus(1, dadoSelecionado);
        this.coluna = "12";
        this.abrirFiscaisPorStatus = false;
      } else if (dadoSelecionado == "Retornos") {
        this.buscaPorStatus(2, dadoSelecionado);
        this.coluna = "12";
        this.abrirFiscaisPorStatus = false;
      } else if (dadoSelecionado == "Em Andamento") {
        this.buscaFiscaisPorStatus(this.tipoTarefaSelecionado.valor, 0, dadoSelecionado);
      } else if (dadoSelecionado == "Respondidas") {
        this.buscaFiscaisPorStatus(this.tipoTarefaSelecionado.valor, 1, dadoSelecionado);
      } else if (dadoSelecionado == "Adiadas") {
        this.buscaFiscaisPorStatus(this.tipoTarefaSelecionado.valor, 2, dadoSelecionado);
      } else if (dadoSelecionado == "Processo Aberto") {
        this.buscaFiscaisPorStatus(this.tipoTarefaSelecionado.valor, 4, dadoSelecionado);
      } else if (dadoSelecionado == "Concluídas") {
        this.buscaFiscaisPorStatus(this.tipoTarefaSelecionado.valor, 3, dadoSelecionado);
      } else if (dadoSelecionado == "Em Vigência") {
        this.buscarLicencas(null, "Licenças em Vigência");
      } else if (dadoSelecionado == "Próximas a Vencer") {
        this.buscarLicencas(0);
      } else if (dadoSelecionado == "Vencidas") {
        this.buscarLicencas(1, "Licenças Vencidas");
      } else {
        this.buscaFiscal(dadoSelecionado);
      }
    },

    abrirTabelaSelecionada(tipoTarefa, textTipoTarefa, statusTarefa, textStatusTarefa) {
      this.buscaPorStatus(tipoTarefa, textTipoTarefa);
      this.buscaFiscaisPorStatus(tipoTarefa, statusTarefa, textStatusTarefa);
    },

    async buscaPorStatus(tipoTarefa, textTipoTarefa) {
      this.abrirFiscal = false;

      this.tipoTarefaSelecionado.texto = textTipoTarefa;
      this.tipoTarefaSelecionado.valor = tipoTarefa;

      try {
        const responseData = await axios.put("/dashboardTarefaStatus", { tipoTarefa: tipoTarefa }, this.config);
        this.dadosDeStatus = responseData.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$vuetify.goTo("#cardTipos");
        this.abrirGraficoDeAbertosEFechados = true;
      }
    },

    async buscaFiscaisPorStatus(tipoTarefa, statusTarefa, textStatusTarefa) {
      this.abrirFiscal = false;

      this.statusTarefaSelecionado.texto = textStatusTarefa;
      this.statusTarefaSelecionado.valor = statusTarefa;

      try {
        const responseData = await axios.put("/dashboardFiscaisPorStatus", { tipoTarefa: tipoTarefa, statusTarefa: statusTarefa }, this.config);
        this.dadosDeFiscaisPorStatus = responseData.data;

        //Cores do gráfico "Ficais por Status"
        for (let index of this.dadosDeFiscaisPorStatus.datasets[0].data.keys()) {
          this.dadosDeFiscaisPorStatus.datasets[0].backgroundColor.push(colorPattern[index]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        (this.coluna = "6"), (this.abrirFiscaisPorStatus = true);
      }
    },

    async buscaFiscal(nomeFiscal) {
      try {
        const responseData = await axios.put("/dashboardFiscal", { nomeFiscal: nomeFiscal }, this.config);

        this.infoFiscal.fotoUsuario = responseData.data.foto;
        this.infoFiscal.nomeUsuario = responseData.data.nomeUsuario;
        this.infoFiscal.cpfUsuario = responseData.data.cpf;
        this.infoFiscal.emailUsuario = responseData.data.email;
      } catch (error) {
        console.log(error);
      } finally {
        this.$vuetify.goTo("#cardFiscais");
        this.abrirFiscal = true;
      }
    },

    async buscarLicencas(statusLicenca, textoTabela) {
      try {
        const responseData = await axios.put("/licenca", { statusLicenca: statusLicenca }, this.config);
        this.listaLicencas = responseData.data;

        if (statusLicenca == null || statusLicenca == 1) {
          this.tituloTabela = textoTabela;
          this.mostrarTabelaComAcao = false;
          this.mostrarTabela = true;
        } else {
          this.mostrarTabela = false;
          this.mostrarTabelaComAcao = true;
          this.listarUsuarios();
          this.listarRoteiros();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$vuetify.goTo("#datatableLicenca");
      }
    },

    async listarUsuarios() {
      try {
        const response = await axios.get("usuarios", this.config);

        this.usuarios = response.data.map(function(usuarioSelecionado) {
          return {
            text: usuarioSelecionado.nomeUsuario,
            value: usuarioSelecionado.numeroUsuario,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async listarRoteiros() {
      try {
        const response = await axios.get("roteiro", this.config);

        this.roteiros = response.data.map(function(roteiroSelecionado) {
          return {
            text: roteiroSelecionado.nomeRoteiro,
            value: roteiroSelecionado.numeroRoteiro,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

    onDataTableUpdateRow(item) {
      this.modalCustomSizeData.isOpen = true;
      this.modalCustomSizeData.isEdit = true;
      this.modalCustomSizeData.buttonText = "Salvar";
      this.modalCustomSizeData.formTitle = "Inserir nova Tarefa";

      this.modalCustomSizeData.actualEdit.numeroEmpresa = item.empresa.numeroEmpresa;
      this.modalCustomSizeData.actualEdit.numeroEndereco = item.endereco.numeroEndereco;
      this.modalCustomSizeData.actualEdit.nomeEmpresa = item.empresa.nomeFantasia;
      this.modalCustomSizeData.actualEdit.nomeEndereco = item.endereco.endereco + ` - ` + item.endereco.cevs;
      this.modalCustomSizeData.actualEdit.numeroUsuario = null;
      this.modalCustomSizeData.actualEdit.numeroRoteiro = null;
      this.modalCustomSizeData.actualEdit.dataTarefa = null;
      this.date = null;
    },

    gerarListaDeAnos() {
      const anoAtual = new Date().getFullYear();
      for (let i = 2021; i <= anoAtual; i++) {
        this.listaAnos.push({
          value: i,
          text: i,
        });
      }
    },

    alterarAno(anoSelecionado) {
      this.anoSelecionado = anoSelecionado;
      this.dadosGraficoRenovacoes();
    },

    //#region FORMATADOR DE DATAS
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    //#endregion

    //#region SCROLL TO TOP
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.mostrarFAB = top > 20;
    },

    irParaTopo() {
      this.$vuetify.goTo(0);
    },
    //#endregion
  },
};
</script>
